import { Background } from './Background';

export const Modules = {
    "background" : Background
}